import { useContext } from 'react';
import { isNewPlayerEnabled } from 'lib/playerFeatureFlag';
import LegacyFormPlayer from './Player';
import NewFormPlayer from './NewFormPlayer';
import FormPlayerContext from './PlayerContext';
import FormPlayerProvider from './PlayerProvider';

const withFormPlayer = (WrappedComponent) => {
    function WithFormPlayer(props) {
        const { player } = useContext(FormPlayerContext);
        return <WrappedComponent {...props} player={player} />;
    }
    WithFormPlayer.displayName = `withFormPlayer(${WrappedComponent.displayName || WrappedComponent.name})`;
    return WithFormPlayer;
};

export const FormPlayer = isNewPlayerEnabled() ? NewFormPlayer : LegacyFormPlayer;
export { FormPlayerContext, FormPlayerProvider, withFormPlayer };
